export const LIVE = {
	memberPage: 'member-live-page',
	sessionCard: 'live-session-card',
	joinBtn: 'live-join-button',
	adminPage: 'admin-live-page',
	adminNewBtn: 'admin-live-new-button',
	adminSaveBtn: 'admin-live-save-button',
	adminRow: 'admin-live-row',
	adminEditBtn: 'admin-live-edit-button',
	adminDeleteBtn: 'admin-live-delete-button',
	mentorPage: 'mentor-live-page',
	mentorNewBtn: 'mentor-live-new-button',
	mentorSaveBtn: 'mentor-live-save-button',
	mentorRow: 'mentor-live-row',
};
